import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Language, SiteData } from '../data/types';
import arData from '../data/ar.json';
import enData from '../data/en.json';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  data: SiteData;
  isRTL: boolean;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>('en');

  const data = language === 'ar' ? (arData as SiteData) : (enData as SiteData);
  const isRTL = language === 'ar';

  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, data, isRTL }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};